import store from '@/store';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import homeOld from '@/components/home/home-old/home-old.vue';

const account = () => import(/* webpackChunkName: "account" */ '@/components/account/account.vue');
const accountDetails = () => import(/* webpackChunkName: "account" */ '@/components/account/account-details/account-details.vue');
const history = () => import(/* webpackChunkName: "account" */ '@/components/account/history/history.vue');
const settings = () => import(/* webpackChunkName: "account" */ '@/components/account/settings/settings.vue');
const profilePage = () => import(/* webpackChunkName: "account" */ '@/components/account/profile-page/profile-page.vue');
const wallet = () => import(/* webpackChunkName: "account" */ '@/components/wallet/wallet.vue');
const accountSocialAuth = () => import(/* webpackChunkName: "account-social-auth" */ '@/components/account/account-social-auth/account-social-auth.vue');
const pageLogin = () => import(/* webpackChunkName: "page-login" */ '@/components/pages/page-login/page-login.vue');
const pageForgottenPassword = () => import(/* webpackChunkName: "page-forgotten-password" */ '@/components/pages/page-forgotten-password/page-forgotten-password.vue');
const pageRegister = () => import(/* webpackChunkName: "page-register" */ '@/components/pages/page-register/page-register.vue');
const pageTaxDetail = () => import(/* webpackChunkName: "page-tax-detail" */ '@/components/pages/page-tax-detail/page-tax-detail.vue');
const accountDisqus = () => import(/* webpackChunkName: "account-disqus" */ '@/components/account/account-disqus/account-disqus.vue');

export default [
  {
    path: '/account',
    component: account,
    props: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'wallet',
        name: 'wallet',
        component: wallet,
      },
      {
        path: '',
        name: 'profile',
        component: profilePage,
        props: true,
      },
      {
        path: 'details',
        name: 'account-details',
        component: accountDetails,
      },
      {
        path: 'details/update',
        name: 'details-update',
        component: accountDetails,
      },
      {
        path: 'address/update',
        name: 'address-update',
        component: accountDetails,
      },
      {
        path: 'password/update',
        name: 'password-update',
        component: accountDetails,
      },
      {
        path: 'password/set',
        name: 'password-set',
        component: accountDetails,
      },
      {
        path: 'history/:marketId?',
        name: 'account-history',
        component: history,
        props: true,
      },
      {
        path: 'settings',
        name: 'account-settings',
        component: settings,
      },
    ],
  },
  {
    path: '/account/password/reset',
    name: 'reset-password',
    component: homeOld,
    beforeEnter: (to, from, next) => {
      store.dispatch('popup/setCurrentPopup', MODALS.RESET_PASSWORD);
      store.dispatch('popup/setCurrentPopupOptions', {
        token: to.query.token,
      });
      next();
    },
    meta: {
      appContentOverflowed: true,
    },
  },
  {
    path: '/account/social/auth',
    name: 'social-auth',
    component: accountSocialAuth,
  },
  {
    path: '/account/disqus',
    name: 'disqus-auth',
    component: accountDisqus,
    props: true,
  },
  {
    path: '/account/disqus/logout/:routeName/:routeParams?',
    name: 'disqus-logout',
    component: accountDisqus,
    props: true,
  },
  {
    path: '/account/login',
    name: 'account-page-login',
    component: pageLogin,
    meta: {
      requiresAnonymous: true,
    },
  },
  {
    path: '/account/sign-up',
    name: 'account-page-register',
    component: pageRegister,
    meta: {
      requiresAnonymous: true,
    },
  },
  {
    path: '/account/password/forgotten',
    name: 'account-password-forgotten',
    component: pageForgottenPassword,
    meta: {
      requiresAnonymous: true,
    },
  },
  {
    path: '/account/taxdetail',
    name: 'account-page-tax-detail',
    component: pageTaxDetail,
    meta: {
      requiresAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/account.js